import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

import type {
  exportTableColumnValidation,
  tableColumnValidation,
  TableSettingColumn,
} from 'types/tableSettingsTypes';

interface AdminSMSTemplateState {
  excludedFilter: string[];
  filterData: Record<string, any>;
  reloadTableData: boolean;
  tableColumnValidation: tableColumnValidation;
  defaultColumnList: TableSettingColumn[];
  tableColumnList: TableSettingColumn[];
  exportTableColumnValidation: exportTableColumnValidation;
  exportTableColumnList: TableSettingColumn[];
}
const defaultColumnList = [
  {
    name: 'name',
    label_key: 'name',
    allow_list: true,
    allow_filter: false,
    show_list_checkbox: true,
    show_filter_checkbox: false,
    order: 1,
  },
  {
    name: 'subject',
    label_key: 'subject',
    allow_list: true,
    allow_filter: false,
    show_list_checkbox: true,
    show_filter_checkbox: false,
    order: 2,
  },
  {
    name: 'created_at',
    label_key: 'created_at',
    allow_list: true,
    allow_filter: false,
    show_list_checkbox: true,
    show_filter_checkbox: false,
    order: 2,
  },
  {
    name: 'status',
    label_key: 'status',
    allow_list: true,
    allow_filter: true,
    show_list_checkbox: true,
    show_filter_checkbox: true,
    type: 'select',
    filter_placeholder: 'status_all',
    selectKey: 'status',
    option_value_key: 'id',
    option_label_key: 'name',
    multi: false,
    order: 2,
  },
];
const exportColumnList = defaultColumnList.map((list) => ({
  ...list,
  allow_list: true,
  show_list_checkbox: true,
}));
const initialState: AdminSMSTemplateState = {
  excludedFilter: ['search'],
  filterData: {},
  reloadTableData: false,
  tableColumnValidation: {
    minListColumn: 2,
    maxListColumn: 8,
    minFilterColumn: 0,
    maxFilterColumn: 8,
  },
  defaultColumnList: defaultColumnList,
  tableColumnList: JSON.parse(JSON.stringify(defaultColumnList)),
  exportTableColumnValidation: {
    minListColumn: 2,
  },
  exportTableColumnList: exportColumnList,
};

const adminSMSTemplateSlice = createSlice({
  name: 'adminSMSTemplate',
  initialState,
  reducers: {
    setFilterData(state, action: PayloadAction<Record<string, any>>) {
      state.filterData = action.payload;
    },
    removeFilterKey(state, action: PayloadAction<string>) {
      delete state.filterData[action.payload];
    },
    resetFilterData(state) {
      state.filterData = {};
    },
    setReloadTableData(state, action: PayloadAction<boolean>) {
      state.reloadTableData = action.payload;
    },
  },
});

export const { setFilterData, removeFilterKey, resetFilterData, setReloadTableData } =
  adminSMSTemplateSlice.actions;

export default adminSMSTemplateSlice.reducer;
